(function(ebusy, $) {

	/**
	 * Initializes tabs.
	 */
	ebusy.initTabs = function() {

		var navTabs = $("form .nav-tabs, form .nav-pills, .content-widgets-wrap .nav-tabs");

		if(!navTabs.length) {
			return;
		}

		var activeTab = ebusy.activeTab && $("a[href='" + ebusy.activeTab + "']").length > 0 ? $("a[href='" + ebusy.activeTab + "']") : navTabs.find("a").first();

		if(activeTab.hasClass("active")) {
			return;
		}

		activeTab.tab("show").closest("form").find("input[name='activeTab']").val(activeTab.attr("href"));

		$(".tab-pane").each(function() {
			if($(".is-invalid", $(this)).length) {
				// FIXME: Bootstrap 4 beta forces .nav-tabs .nav-link-active color with !important, so
				// .text-danger doesn't work in backend form tabs. Example: court module prices view tabs.
				$("a[href='#" + $(this).attr("id") + "']").append("&nbsp;<i class='icon-notification-circle'></i>").addClass("text-danger");
			}
		});
	}

})(window.ebusy = window.ebusy || {}, window.jQuery);

$(function() {

	/**
	 * Save tab on click.
	 */
	$(document).on("click", "a[data-toggle='tab']", function() {
		
		if(!$(this).closest("form").length) {
			history.replaceState({}, '', ebusy.addParam(window.location.href, "activeTab", $(this).attr("href")));
			return;
		}
		
		$(this).closest("form").find("input[name='activeTab']").val($(this).attr("href"));
	});

	/**
	 * Init tabs on form init.
	 */
	$(document).on("form.init", function() {
		ebusy.initTabs();
	});

	/**
	 * Init existing tabs.
	 */
	ebusy.initTabs();

});
